import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SimCardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sim_card"}/>
}
